export { owaConnectedAccountAdded } from './actions/publicActions';

import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "owa-account-store-init", webpackPrefetch: true */ './lazyIndex')
);

export const lazyInitializeOwaAccountsStore = new LazyAction(
    lazyModule,
    m => m.initializeOwaAccountsStore
);

export const lazyInitializeOwaConnectedAccount = new LazyImport(
    lazyModule,
    m => m.initializeOwaConnectedAccount
);

export const lazyRemoveOWAConnectedAccount = new LazyAction(
    lazyModule,
    m => m.removeOWAConnectedAccount
);
